import { Overlay2 } from "@blueprintjs/core";
import { ReactElement, useState } from "react";
import { CloseIcon } from "@chakra-ui/icons";
import { themeColours } from "../../resources";

export function InfoModal({
  element,
  heading,
  texts,
  buttonText,
  onButtonClick,
  onOpenClick,
  modalClassName,
}: {
  element: ReactElement;
  heading: string;
  texts: ReactElement[];
  buttonText?: string;
  onButtonClick?: () => void;
  onOpenClick?: () => void;
  modalClassName?: string
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [isClosed, setIsClosed] = useState(true);

  function handleOpenClick() {
    setIsOpen(true);
    setIsClosed(false);
    if(onOpenClick) onOpenClick()
  }

  function handleCloseClick() {
    setIsOpen(false);
    setIsClosed(true);
  }

  const className = modalClassName ?? 'modalOverlay modalInfo'

  return (
    <>
      <span onClick={handleOpenClick} className="editNameSpan">
        {element}
      </span>
      {isOpen && (
        <Overlay2 isOpen={isOpen} className={isClosed ? "" : className} hasBackdrop={true}>
          <div className="modalContainer">
            <div className="modalContent">
              <span className="modalHeader">
                <span className="closeModalSpan">
                  <CloseIcon onClick={handleCloseClick} color={themeColours.secondary} boxSize={3} />
                </span>
                <h1 className="modalHeading">{heading}</h1>
              </span>
              {texts.map((text) => text)}
              {buttonText && (
                <button className="primaryButton modalSingleButton" onClick={onButtonClick}>
                  {buttonText}
                </button>
              )}
            </div>
          </div>
        </Overlay2>
      )}
    </>
  );
}
